import { createSlice } from "@reduxjs/toolkit";

export const addressproofSlice = createSlice({
  name: "addressproof",
  initialState: {
    error: "Sorry! No Data Found.",
    message: null,
    loading: false,
    addressprooflist: [],
    model: false,
    error_msg: null,
    rowdata: {},
    addressproofParams: {
      no_of_pages: 0,
      listCount: 0,
      page_size: 10,
      page: 1,
      search: "",
      currentSort: "code",
      sortOrder: "-",
    },
  },
  reducers: {
    getAddressproofs: (state) => {
      return {
        ...state,
        loading: true,
      };
    },
    addressproofListSuccessful: (state, action) => {
      var noofpages = Math.ceil(
        action.payload.response.count / state.addressproofParams.page_size
      );

      return {
        ...state,
        listCount: action.payload.response.count,
        addressprooflist: action.payload.response.results,
        loading: false,
        addressproofParams: {
          ...state.addressproofParams,
          no_of_pages: noofpages,
        },
      };
    },
    addressproofAdd: (state) => {
      return {
        ...state,
        loading: false,
      };
    },
    addressproofAddSuccessful: (state, action) => {
      return {
        ...state,
        message: action.payload,
        loading: false,
        model: false,
        rowdata: {},
      };
    },
    addressproofEdit: (state, action) => {
      return {
        ...state,
        model: true,
        rowdata: action.payload,
      };
    },
    addressproofEditSuccessful: (state) => {
      return { ...state, loading: false, rowdata: {} };
    },
    addressproofDelete: (state) => {
      return {
        ...state,
        loading: false,
      };
    },
    InputChangeValue: (state, action) => {
      return {
        ...state,
        rowdata: {
          ...state.rowdata,
          [action.payload.key]: action.payload.value,
        },
      };
    },
    isModelVisible: (state, action) => {
      if (!action.payload) {
        return {
          ...state,
          model: action.payload,
          rowdata: {},
        };
      } else {
        return {
          ...state,
          model: action.payload,
        };
      }
    },
    SetAddressproofsParams: (state, action) => {
      return {
        ...state,
        addressproofParams: action.payload,
      };
    },
    apiError: (state, action) => {
      return { ...state, loading: false, error_msg: action.payload };
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  getAddressproofs,
  addressproofListSuccessful,
  addressproofAdd,
  addressproofAddSuccessful,
  addressproofEdit,
  addressproofEditSuccessful,
  addressproofDelete,
  InputChangeValue,
  apiError,
  isModelVisible,
  SetAddressproofsParams
} = addressproofSlice.actions;

export default addressproofSlice.reducer;
